import React, {useEffect, useRef, useState} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import {red} from "@material-ui/core/colors";
import Divider from "@material-ui/core/Divider";
import {Comment, NoCommentsMessage} from "./Comment";
import request from "../../../../../../Services/API/Requests";
import CommentInput from "./CommentInput";

const useStyles = makeStyles((theme) => ({
    container: {
        padding: 10
    },
    commentContainer: {
        padding: '10px 5px',
        marginBottom: 10,
        '&:hover': {
            background: '#fbfbfb',
            '& $reply': {
                visibility: "visible"
            }
        }
    },
    replyContainer: {
        padding: '5px 10px'
    },
    reply: {
        visibility: 'hidden',
        fontSize: '0.8rem',
        '&:hover': {
            textDecoration: 'underline',
            color: theme.palette.primary.main,
            cursor: 'pointer'
        }
    },
    avatar: {
        backgroundColor: red[500],
        width: 30,
        height: 30
    },
    title: {
        paddingLeft: 10,
        flexGrow: 1
    },
    headText: {
        fontSize: '0.9rem',
        lineHeight: 1.1
    },
    commentHeader: {
        padding: 10,
        display: 'flex',
        alignItems: 'center'
    }
}));

const Comments = (props) => {
    const {feedComments = [], feedId, uniqueUsers, entity} = props;
    const [replyComment, setReplyComment] = useState({text: '', author: '', refId: null});
    const [comments, setComments] = useState([]);
    const inputRef = useRef();
    const scrollAnchor = useRef();

    useEffect(() => {

        let newComments = richComments(feedComments, uniqueUsers);

        setComments(newComments);
    }, [feedComments.length]);


    function onClickReply(refId) {
        const findReply = comments.findIndex(c => c._id === refId);
        if (findReply === -1) return;
        scrollAnchor.current.scrollIntoView({behavior: 'smooth'});
        setTimeout(() => {
            inputRef.current && inputRef.current.focus();
        }, 30);
        const replyMsg = comments[findReply].message.slice(0, 50) + "....";
        const replyAuthor = comments[findReply].author;
        setReplyComment({
            text: replyMsg,
            author: replyAuthor,
            refId
        })
    }

    async function onClickDelete(id) {
        try {
            const response = await request({
                url: `${entity}/deleteComment`,
                data: {
                    id: feedId,
                    commentId: id
                }
            });
            let newComments = richComments(response.comments, uniqueUsers);
            setComments(newComments);
        } catch (e) {
            console.log(e)
        }
    }

    async function sendMessage(message) {
        try {
            const response = await request({
                url: `${entity}/createComment`,
                data: {
                    id: feedId,
                    message,
                    replyRef: replyComment.refId
                }
            });
            let newComments = richComments(response.comments, uniqueUsers);
            setComments(newComments || []);
            setReplyComment({text: '', author: ''});
        } catch (e) {

        }
    }


    const classes = useStyles();
    return (
        <div className={classes.container}>
            <Typography style={{fontSize: '1.2rem', padding: '15px 0'}}>
                Comments: {comments.length || 0}
            </Typography>
            <Divider/>
            {comments.length ? (
                comments.map(comment => (
                    <Comment
                        key={comment._id}
                        author={comment.author}
                        created={comment.createdDate}
                        message={comment.message}
                        deleted={Boolean(comment.deleted)}
                        replyComment={comment.replyRef ? comments.find(c => c._id === comment.replyRef) : {}}
                        onClickReply={() => onClickReply(comment._id)}
                        onClickDelete={() => onClickDelete(comment._id)}
                    />
                ))
            ) : (
                <NoCommentsMessage/>
            )}
            <CommentInput
                refComment={replyComment}
                inputRef={inputRef}
                removeReplying={() => {
                    setReplyComment({text: "", author: ""});
                    inputRef.current.focus();
                }}
                sendMessage={sendMessage}
            />
            <div ref={scrollAnchor}/>
        </div>
    )
};

export default Comments

/**
 *
 * @param feedComments
 * @param uniqueUsers
 * @returns {*}
 */
function richComments(feedComments, uniqueUsers) {
    return feedComments.map(fc => {
        let author = uniqueUsers.find(u => u._id === fc.author);
        return {...fc, author: author || {name: fc.author}}
    });
}